<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center font-weight-bold" style="font-size: 16px;">
        <router-link :to="backPath" class="d-flex align-items-center text-dark mr-2">
          <i class="fas fa-chevron-left mr-2"></i>
          <span>Back</span>
        </router-link>
        <span class="text-muted mx-2">|</span>
        <router-link :to="backPath" class="text-muted decoration-none mx-2">{{ backLabel }}</router-link>
        <i class="fas fa-chevron-right mx-2 text-muted"></i>
        <span class="text-dark">{{ detail.package || '-' }}</span>
      </div>
      <button
        type="button"
        class="btn shadow bg-white"
        @click="downloadCsv"
        :disabled="loading || !rows.length">
        <i class="fas fa-file-download mr-2"></i>
        Download CSV
      </button>
    </div>

    <div class="bg-white rounded shadow-sm">
      <div class="d-flex flex-wrap" style="gap: 24px; padding: 20px;">
        <div style="flex: 1; min-width: 200px;">
          <div class="text-muted">Dealer</div>
          <div class="font-weight-bold">{{ dealerLabel }}</div>
        </div>
        <div style="flex: 1; min-width: 200px;">
          <div class="text-muted">Status</div>
          <div class="font-weight-bold">{{ detail.status || '-' }}</div>
        </div>
        <div style="flex: 1; min-width: 200px;">
          <div class="text-muted">Date &amp; Time Order</div>
          <div class="font-weight-bold">{{ formatDateTime(detail.delivery_at || detail.created_at) }}</div>
        </div>
        <div style="flex: 1; min-width: 200px;">
          <div class="text-muted">Created by</div>
          <div class="font-weight-bold">{{ detail.sender_name || '-' }}</div>
        </div>
        <div style="flex: 1; min-width: 200px;">
          <div class="text-muted">Date &amp; Time Receive</div>
          <div class="font-weight-bold">{{ formatDateTime(detail.received_at) }}</div>
        </div>
      </div>

      <div class="bg-white rounded shadow-sm mt-3">
        <div class="w-100 overflow-auto" style="height: 100vh; overflow-y: auto;">
          <table class="table w-100 qtrust-table">
            <thead>
              <tr>
                <th style="width: 33.33%; padding-left: 20px;">No</th>
                <th style="width: 33.33%;">Serial Number</th>
                <th style="width: 33.34%;">Konten QR</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="3">Loading...</td>
              </tr>
              <tr v-else-if="!rows.length">
                <td colspan="3">No data</td>
              </tr>
              <tr v-else v-for="(row, index) in rows" :key="row.serial_number || index">
                <td style="padding-left: 20px;">{{ index + 1 }}</td>
                <td>{{ row.serial_number || '-' }}</td>
                <td>{{ row.qrcode || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  metaInfo: {
    title: 'QR Issue Detail',
  },
  data() {
    return {
      rows: [],
      loading: false,
      detail: {},
    };
  },
  computed: {
    dealerLabel() {
      if (this.detail.dealer_type) return `Dealer ${this.detail.dealer_type}`;
      return this.detail.kode_dealer || '-';
    },
    backPath() {
      return this.$route.name === 'QRHistoryIssueDetail' ? '/qr-code/history' : '/qr-code/qr-stock';
    },
    backLabel() {
      return this.$route.name === 'QRHistoryIssueDetail' ? 'History QR' : 'Stock QR';
    },
  },
  mounted() {
    this.fetchDetail();
    this.fetchItems();
  },
  methods: {
    fetchDetail() {
      const id = this.$route.params.id;
      if (!id) return;
      this.$http
        .get(`/api/qrs/issue/${id}`)
        .then((resp) => {
          this.detail = resp && resp.data ? resp.data.data || {} : {};
        })
        .catch((err) => {
          console.log(err);
          this.detail = {};
        });
    },
    fetchItems() {
      const id = this.$route.params.id;
      if (!id) return;

      this.loading = true;
      this.$http
        .get(`/api/qrs/issue/${id}/items`)
        .then((resp) => {
          const payload = resp && resp.data ? resp.data.data || resp.data : [];
          this.rows = Array.isArray(payload) ? payload : [];
        })
        .catch((err) => {
          console.log(err);
          this.rows = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      const pad = (n) => n.toString().padStart(2, '0');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const day = pad(date.getDate());
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hour = pad(date.getHours());
      const min = pad(date.getMinutes());
      return `${day} ${month} ${year} | ${hour}:${min}`;
    },
    downloadCsv() {
      if (!this.rows.length) return;
      const data = this.rows.map((row, idx) => ({
        No: idx + 1,
        'Serial Number': row.serial_number || '-',
        'Konten QR': row.qrcode || '-',
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const filename = `qr_issue_${this.detail.package || this.$route.params.id}.csv`;
      XLSX.writeFile(workbook, filename, { bookType: 'csv' });
    },
  },
};
</script>